import { Action, Selector, State, StateContext } from '@ngxs/store';
import { TransportManagementFilterName } from '../constants/transport-management.constant';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import {
  TransportManagementFiltersLoad,
  TransportManagementFilterUpdate,
  TransportManagementFiltersInitialState,
} from './transport-management-filters.actions';
import { TransportManagementFiltersService } from './transport-management-filters.service';
import { NotificationService } from '../../../../../common/services/notification/notification.service';
import { Error, CustomHttpErrorResponse } from '../../../../../common';
import { MatSnackBarRef, SimpleSnackBar } from '@angular/material/snack-bar';

export interface TransportManagementFiltersStateModel {
  items: TransportManagementFilterName[];
  loaded: boolean;
}

const initialState: TransportManagementFiltersStateModel = {
  items: [],
  loaded: false,
};

@State({
  name: 'transportManagementFilters',
  defaults: initialState,
})
@Injectable()
export class TransportManagementFiltersState {
  constructor(
    private transportManagementFiltersService: TransportManagementFiltersService,
    private notificationService: NotificationService,
  ) {}

  @Selector()
  static getState(state: TransportManagementFiltersStateModel): TransportManagementFiltersStateModel {
    return state;
  }

  @Selector()
  static getItems(state: TransportManagementFiltersStateModel): TransportManagementFilterName[] {
    return state.items;
  }

  @Selector()
  static getLoaded(state: TransportManagementFiltersStateModel): boolean {
    return state.loaded;
  }

  @Action(TransportManagementFiltersLoad)
  getTransportManagementFilters(
    ctx: StateContext<TransportManagementFiltersStateModel>,
  ): Observable<MatSnackBarRef<SimpleSnackBar> | void> {
    return this.transportManagementFiltersService.getTransportManagementFilters().pipe(
      map((filters: TransportManagementFilterName[]) => {
        ctx.patchState({ items: filters, loaded: true });
      }),
      catchError(({ error }: CustomHttpErrorResponse<Error>) => of(this.notificationService.error(error.message))),
    );
  }

  @Action(TransportManagementFilterUpdate)
  updateTransportManagementFilters(
    ctx: StateContext<TransportManagementFiltersStateModel>,
    { payload }: TransportManagementFilterUpdate,
  ): Observable<MatSnackBarRef<SimpleSnackBar> | void> {
    return this.transportManagementFiltersService.updateTransportManagementFilters(payload).pipe(
      map((filters: TransportManagementFilterName[]) => {
        ctx.patchState({ items: filters, loaded: true });
        this.notificationService.success('api.transportFilters.success.update');
      }),
      catchError(({ error }: CustomHttpErrorResponse<Error>) => of(this.notificationService.error(error.message))),
    );
  }

  @Action(TransportManagementFiltersInitialState)
  setInitialState(ctx: StateContext<TransportManagementFiltersStateModel>): void {
    ctx.setState(initialState);
  }
}
